/**
 * Google's consent page returns to `/konto/google?code=…&state=…`. `public/oauth-return.js` lifts
 * those three parameters off the address before any module runs, so nothing that boots ever sees
 * the code: the Supabase client (`detectSessionInUrl` would take a `?code=` for its own PKCE
 * callback), Sentry's history breadcrumbs, and the Referer of every later same-origin request.
 * The return hook takes the values once.
 */

export const GOOGLE_RETURN_PATH = '/konto/google';

/** Where `public/oauth-return.js` leaves what it lifted. */
const HELD = '__movebuddyOAuthReturn';

export interface OAuthReturnParams {
  readonly code: string | null;
  readonly state: string | null;
  readonly error: string | null;
}

const NOTHING: OAuthReturnParams = { code: null, state: null, error: null };

function stringOrNull(value: unknown): string | null {
  return typeof value === 'string' ? value : null;
}

/** The parameters this document arrived with, once; every later call answers nothing. */
export function takeOAuthReturn(): OAuthReturnParams {
  const scope = globalThis as Record<string, unknown>;
  const held = scope[HELD];
  Reflect.deleteProperty(scope, HELD);
  if (typeof held !== 'object' || held === null) return NOTHING;
  const { code, state, error } = held as Record<string, unknown>;
  return { code: stringOrNull(code), state: stringOrNull(state), error: stringOrNull(error) };
}
